<!-- <app-header-one ></app-header-one> -->
<app-header-latest></app-header-latest>

<section class="terms-popup">
    <div class="popup-container">
        <div class="popup-card">

            <h1 style="text-align: center;">Refund Policy</h1>

        <p>
        NeoJobz's Refund Policy is as follows:
        </p>

        <p>
        <strong>• Job Postings:</strong> No refunds will be issued for job postings once the job is live on the Portal.
        </p>

        <p>
        <strong>• Subscription Plans:</strong> Refunds for subscription plans will be considered on a case-by-case basis. Pro-rated refunds may be offered if the service is cancelled before the end of the subscription period.
        </p>

        <p>
        <strong>• Resume Access:</strong> No refunds will be issued for resume database access once resumes have been downloaded.
        </p>

        <p>
        <strong>• Resume Building &amp; Feature Listings:</strong> No refunds are issued once the Resume is created or downloaded. No refunds are entertained for Feature Listings once used.
        </p>

        <p>
        <strong>• Advertising and Sponsorships:</strong> Refunds for advertising services are not permitted once the advertisement has been displayed or the campaign has started.
        </p>

        <h2>General Refund Policy</h2>

        <p>
        <strong>•</strong> All refund requests will be reviewed on a case-by-case basis.
        </p>

        <p>
        <strong>•</strong> The company reserves the right to deny any refund request that does not meet the eligibility criteria.
        </p>

        <p>
        <strong>•</strong> The company is not responsible for any indirect, incidental, or consequential damages arising from the use of the platform.
        </p>

        <p>
        <strong>•</strong> Refund requests must be submitted in writing and may require documentation to support the claim.
        </p>

        <h2>Contact Information</h2>

        <p>
        <strong>•</strong> For questions or concerns about refunds, contact us at:
        </p>

        <p>
                <strong>By email:</strong>
                <a href="mailto:support@neojobz.com">
                    support&#64;neojobz.com
                </a>
            </p>

        <p>
        <strong>Phone:</strong>
        +91-70 75 74 5784
        </p>

        <p>
        <strong>•</strong> Review our Terms &amp; Conditions and Privacy Policy for further details.
        </p>

        </div>
           </div>
</section>

<app-footer-more-info></app-footer-more-info>
            <!-- <h2 class="title" >{{tncData.title}}</h2>
            <div [innerHTML]="tncData.description"></div> -->
          
        <!-- <div class="popup-card">
            <h2 class="title" style="cursor: pointer;">Refund Policy</h2>

    <p>WhiteRobe’sRefund Policy for both Job Portal and Matrimony Services are as follows -</p>

    <h2>1. Job Portal</h2>
    <ul>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong>1.1. Job Postings:</strong> No refunds will be issued for job postings once the job is live on the Portal.</li><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong>1.2. Subscription Plans:</strong> Refunds for subscription plans will be considered on a case-by-case basis. Pro-rated refunds may be offered if the<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; service is cancelled before the end of the subscription period. The refund will be done within 30 days.</li><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  <li><strong>1.3. Resume Access:</strong> No refunds will be issued for resume database access once resumes have been downloaded.</li><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong>1.4. Advertising and Sponsorships:</strong> Refunds for advertising services are not permitted once the ad has been displayed or the campaign has started.</li>
    </ul>
<br>
    <h2>2. Matrimony</h2>
    <ul>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong>2.1.	Membership Fees:</strong></li>
            <ul>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<li>•	Refunds for membership fees are generally not provided once the membership period has commenced.</li><br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<li>•	Exceptions may be considered in cases of:  </li><br>
                    <ul>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	   Account closure due to unforeseen circumstances (e.g., medical reasons, marriage).</li><br>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	Technical issues that severely limit the user's ability to use the platform.</li><br>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	Fraudulent activity detected on the user's account.</li><br>
                    </ul>
              
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  <li>•	Refund requests must be submitted in writing and may require documentation to support the claim. The refund will be done within 30 days.</li><br>
            </ul>
        
    </ul>
<br>
    <h2>General Refund Policy</h2>
    <ul>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	All refund requests will be reviewed on a case-to-case basis.</li><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	The company reserves the right to deny any refund request that does not meet the eligibility criteria.</li><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	The company is not responsible for any indirect, incidental, or consequential damages arising from the use of the platform.</li><br>
    </ul>
<br>
    
        <h2>Contact Information for Both Jobs and Matrimonial Services</h2>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <p>•	For questions or concerns about cancellations, contact us at:</p>
    <ul >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong><i class="fa fa-envelope-o"></i>	Email:</strong> <a href="mailto:support&#64;whiterobe.in"> support&#64;whiterobe.in</a></li><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong><i class="fa fa-phone"></i>	Phone:</strong> +91-70 75 85 5784</li><br>
    </ul>

    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <p>•	Review our  <a (click)="goTo('/terms-and-conditions')">Terms & Conditions</a> and <a (click)="goTo('/privacy')">Privacy Policy</a> for further details.</p>
    </div> -->
<!-- <app-footer-one></app-footer-one> -->

